import React from "react";

const CocinaIcon = () => (
  <svg
    style={{ color: "#0f0f0f", fontSize: "16px", width: "16px", height: "16px" }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5 11.5h14"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11.5c0 4.142 2.91 7 5 7s5-2.858 5-7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 7.5c0-1 1-1.5 1-2.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M12 7.5c0-1 1-1.5 1-2.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M15 7.5c0-1 1-1.5 1-2.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export default CocinaIcon;
